import React, { useState, useEffect } from 'react';
import API from '../services/api';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import '../App.css';

const ResetPassword = () => {
    const [data, setData] = useState({ code: '', newPassword: '' });
    const [loading, setLoading] = useState(false);
    const [resending, setResending] = useState(false);
    const [timer, setTimer] = useState(0);
    const navigate = useNavigate();
    // Email localStorage se utha rahay hain jo Forgot page par save ki thi

    const email = localStorage.getItem('userEmail');



    useEffect(() => {

        let interval;

        if (timer > 0) {

            interval = setInterval(() => {

                setTimer((prev) => prev - 1);

            }, 1000);

        }

        return () => clearInterval(interval);

    }, [timer]);



    const handleResendCode = async () => {

        if (!email) return toast.error("Email not found. Please go back.");

        setResending(true);

        try {

            await API.post(`/forgot-password?email=${email}`);

            toast.success("New code sent to your email!");

            setTimer(60);

        } catch (error) {

            toast.error("Failed to resend code.");

        } finally {

            setResending(false);

        }

    };



   const handleReset = async (e) => {

    e.preventDefault();

    setLoading(true);

    try {

        // URL params ki jagah JSON object bhejein

        await API.post("/reset-password", {

            email: email,

            code: data.code,

            new_password: data.newPassword // Ab symbols ka masla nahi hoga!

        });

        toast.success("Password updated successfully!");

        navigate('/login');

    } catch (error) {

        toast.error(error.response?.data?.detail || "Reset failed");

    } finally {

        setLoading(false);

    }

};



    return (

        <div className="main-bg">

            {/* --- SIDE BRAND SECTION WAPIS AA GAYA --- */}

            <div className="brand-section">

                <h1>Cortex</h1>

                <p>Lost your way?<br/>Let's get your account back on track.</p>

            </div>



            <div className="auth-container">

                <h2>Reset Password</h2>

                <p className="sub-text" style={{color: 'white', marginBottom: '29px'}}>Enter the 6-digit code and new password</p>

               

                <form onSubmit={handleReset}>

                    <input

                        type="text"

                        placeholder="6-Digit Code"

                        onChange={(e) => setData({...data, code: e.target.value})}

                        required

                    />

                    <input

                        type="password"

                        placeholder="New Password"

                        onChange={(e) => setData({...data, newPassword: e.target.value})}

                        required

                    />

                    <button type="submit" disabled={loading}>

                        {loading ? <span className="spinner"></span> : "Update Password"}

                    </button>

                </form>



                {/* Resend Logic */}

                <div style={{ marginTop: '20px', textAlign: 'center' }}>

                    <p style={{ color: 'white', fontSize: '14px' }}>

                        Didn't receive the code?{' '}

                        {timer > 0 ? (

                            <span style={{ color: '#aaa' }}>Resend in {timer}s</span>

                        ) : (

                            <span

                                className="white-link"

                                onClick={handleResendCode}

                                style={{ cursor: resending ? 'not-allowed' : 'pointer', fontWeight: 'bold' }}

                            >

                                {resending ? <span className="spinner" style={{ width: '12px', height: '12px', borderWidth: '2px' }}></span> : "Resend Code"}

                            </span>

                        )}

                    </p>

                </div>

            </div>

        </div>

    );

};



export default ResetPassword;

